import { Injectable } from '@angular/core';
import { UserStateDataEntryValue } from '@osos/shared/api';
import { UserStateDataPresenterModel } from '@osos/shared/types';
import { ParserBase } from '../../bases';
@Injectable({
  providedIn: 'root',
})
export class UserStateDataParserV1Service extends ParserBase<
  UserStateDataEntryValue,
  UserStateDataPresenterModel
> {
  constructor() {
    super(UserStateDataEntryValue, UserStateDataPresenterModel, 1);
  }
  override getPresenterModel(
    model: Partial<UserStateDataEntryValue>,
  ): UserStateDataPresenterModel {
    return {
      dateFormat: model.dateFormat,
      dateTimeFormat: model.dateTimeFormat,
      firstLogin: model.firstLogin,
      fontSize: model.fontSize,
      language: model.language,
      layoutMode: model.layoutMode,
      menuMode: model.menuMode,
      theme: model.theme,
      timeFormat: model.timeFormat,
      timeZone: model.timeZone,
      user: model.user,
    } as UserStateDataPresenterModel;
  }
  override getDataModel(
    presenter: UserStateDataPresenterModel,
  ): UserStateDataEntryValue {
    return {
      dateFormat: presenter.dateFormat,
      dateTimeFormat: presenter.dateTimeFormat,
      firstLogin: presenter.firstLogin,
      fontSize: presenter.fontSize,
      language: presenter.language,
      layoutMode: presenter.layoutMode,
      menuMode: presenter.menuMode,
      theme: presenter.theme,
      timeFormat: presenter.timeFormat,
      timeZone: presenter.timeZone,
      user: presenter.user,
    } as UserStateDataEntryValue;
  }
}
